module.exports = __webpack_public_path__ + "img/th-box4-text-light.8f56e731.png";